import type { Locale } from '@change-corgi/config/locales';

// CHANGE-95457: en-default markets per experiment targeting (US, GB, CA, AU, NZ, IE via
// geoip.country_code). NZ and IE have no locale of their own — per packages/config's country→locale
// map they resolve to en-AU and en-GB respectively, so those two are already covered here. en-IN is
// deliberately excluded: it's an English UI locale but not one of the targeted markets.
const EN_DEFAULT_MARKET_LOCALES = new Set<Locale>(['en-US', 'en-GB', 'en-CA', 'en-AU']);

export function isEnDefaultMarketLocale(locale: string): boolean {
	return EN_DEFAULT_MARKET_LOCALES.has(locale as Locale);
}
